import React, { Component } from 'react';
import { Text, ViewBox } from '../common';
import styled from 'styled-components';
import { Flex, Box } from 'rebass';
import { colors } from '../../tailwind';
import moment from 'moment';

export default class DashboardReviews extends Component {
  buildReviewJSX(review, idx, totalReviews) {
    const { listId, hostId, guestId, displayName, threadId, reviewType } = review;

    return (
      <Flex
        key={threadId || listId + hostId + guestId}
        justifyContent="space-between"
        py="24px"
        flexWrap="wrap"
        style={{
          borderBottom:
            idx < totalReviews - 1
              ? `solid 0.5px ${colors.coolGrayLight}`
              : `solid 0.5px ${colors.coolGrayLight}`,
        }}
      >
        <Flex alignItems="center">
          <Flex flexWrap="wrap" justifyContent="space-between">
            <Flex alignItems="center" justifyContent="space-between">
              <Text>
                {reviewType === 'PUBLIC' ? (
                  <Flex>
                    <Text bold inline pr={1}>
                      {displayName}
                    </Text>
                    <Text>
                      {' '}
                      has left you a review. This review is now public.
                    </Text>
                  </Flex>
                ) : null}
              </Text>
            </Flex>
            <Flex alignItems="center" style={{ minWidth: 161 }}>
              {reviewType === 'PRIORRESERVATION' ? (
                <Text>
                  Would you like to
                  <Text bold inline p={1}>
                    leave a review
                  </Text>
                  for {displayName}?
                </Text>
              ) : null}
            </Flex>
          </Flex>
        </Flex>
        <Flex alignItems="center">
          <RemoveReview link>x</RemoveReview>
        </Flex>
      </Flex>
    );
  }

  buildReview(reviews, priorReservations) {
    const reviews2 = reviews
      ? reviews.map(review => ({
          listId: review.listId,
          hostId: review.hostId,
          guestId: review.guestId,
          displayName: review.guestProfile.displayName,
          threadId: review.threadItemUnread.threadId,
          createdAt: new Date(review.threadItemUnread.createdAt),
          reviewType: 'PUBLIC',
        }))
      : [];
    const priorReservations2 = priorReservations
      ? priorReservations.map(reservation => {
          const startMonth = moment(reservation.checkIn).format('MMM');
          const startDay = moment(reservation.checkIn).format('D');
          const endMonth = moment(reservation.checkOut).format('MMM');
          const endDay = moment(reservation.checkOut).format('D');
          const range =
            startMonth === endMonth
              ? `${startMonth} ${startDay} - ${endDay}`
              : `${startMonth} ${startDay} - ${endMonth} ${endDay}`;
          return {
            listId: reservation.listId,
            hostId: reservation.hostId,
            guestId: reservation.guestId,
            displayName: reservation.guestData.displayName,
            picture: reservation.guestData.picture,
            title: reservation.listData.title,
            createdAt: new Date(reservation.createdAt),
            reviewType: 'PRIORRESERVATION',
            checkIn: reservation.checkIn,
            checkOut: reservation.checkOut,
            reservationRange: range,
            total: reservation.total,
          };
        })
      : [];
    const newArr = [...reviews2, ...priorReservations2].sort((a, b) => {
      const key1 = a.createdAt;
      const key2 = b.createdAt;

      if (key1 < key2) {
        return -1;
      } else if (key1 == key2) {
        return 0;
      }
      return 1;
    });
    return newArr;
  }

  render() {
    const { reviews, priorReservations, loading } = this.props;
    const reviewCount = reviews.length || 0;
    return (
      <ViewBox
        header={`New Reviews (${reviewCount})`}
        loading={loading}
        style={{ width: '100%', maxWidth: '1000px' }}
      >
        {!reviews ? (
          <Flex justifyContent="center" alignItems="center" height="100%">
            <Text inline large center>
              No reviews found.
            </Text>
          </Flex>
        ) : (
          this.buildReview(reviews, priorReservations)
            .slice(0, 3)
            .map((review, idx) => this.buildReviewJSX(review, idx, reviewCount))
        )}
        {reviewCount > 2 && (
          <Text link pt="24px">
            See all reviews
          </Text>
        )}
      </ViewBox>
    );
  }
}

const RemoveReview = styled.div`
  color: ${colors.coolGray}
  font-size: 20px;
`;



// WEBPACK FOOTER //
// ./src/components_new/dashboard/DashboardReviews.js